import React, { useState, useEffect, useMemo, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css'
import {sdk} from './sdk.js';
import {sdkLocal} from './sdkLocal.js';
import './SocialCreatePost.css';
import { NewSocialPostForm } from "./NewSocialPostForm";

const SocialCreatePost = ({ user, page, group, setNewPost }) => {
  const [modalOpen, setModalOpen] = useState(false);

  const toggleModal = () => {
    setModalOpen(!modalOpen);
  };

  return (
    <div className="new-post-container">
      {!modalOpen && (
        <div className="new-post" onClick={toggleModal}>
          {user && (
            <>
              <img
                src={`https://peupleqc.com/s/peupleqc-upload/${user.avatar}`}
                alt="Avatar"
                className="new_post_avatar"
              />
              <input type="text" placeholder="Quoi de neuf ?" readOnly />
            </>
          )}
          {page && (
            <>
              <img
                src={`https://peupleqc.com/s/peupleqc-upload/${page.avatar}`}
                alt="Avatar"
                className="new_post_avatar"
              />
              <input type="text" placeholder="Quoi de neuf ?" readOnly />
            </>
          )}
        </div>
      )}
      <NewSocialPostForm
        isOpen={modalOpen}
        page={page}
        user={user}
        group={group}
        setNewPost={setNewPost}
        toggleModal={toggleModal}
      />
    </div>
  );
};

export { SocialCreatePost };
